import React, { useRef } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import { useSelector } from 'react-redux'
import type { ITheme } from '@homeviews/styles'
import { AwardsTable } from '@homeviews/statistics'
import {
  LockedContentHeader,
  Typography,
  Card,
  WindowTitle,
} from '@homeviews/shared-ui'
import { isStandardDeveloperUser } from '@homeviews/store'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
    chartSource: {
      marginTop: 20,
      marginBottom: 20,
    },
    introText: {
      marginBottom: 15,
      color: theme.colors.grey800,
    },
    card: {},
  }),
)
const Development: React.FC = () => {
  const classes = useStyles()
  const awardsGrid = useRef(null)
  const isStandardDeveloper = useSelector(isStandardDeveloperUser)

  const chartSource = () => (
    <div className={classes.chartSource}>
      <Typography>Source: HomeViews</Typography>
    </div>
  )

  return (
    <>
      <WindowTitle title="Awards" />
      <div className={classes.root}>
        <Grid item xs={12} ref={awardsGrid}>
          <Card
            className={classes.card}
            header={
              <LockedContentHeader isLocked={isStandardDeveloper}>
                <Typography variant="h3" className="l-lockedContent__title">
                  Awards
                </Typography>
              </LockedContentHeader>
            }
          >
            {!isStandardDeveloper && (
              <>
                <Typography className={classes.introText}>
                  Below you can see any HomeViews Awards your developments have
                  won. Make sure to use these in your marketing, on your website
                  and across internal communications
                </Typography>
                <AwardsTable
                  gridRef={awardsGrid?.current}
                  activeFilters={{}}
                  graphDisabled={false}
                />
                {chartSource()}
              </>
            )}
          </Card>
        </Grid>
      </div>
    </>
  )
}

export default Development
